import { connect } from 'react-redux';

import type { AccommodationState } from '@/interfaces';
import displayValues from '@/assets/displayValues.json';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { actions as filterActions } from '@/state/filterActions';
import { SortDropdown, type SortDropdownStateProps } from '@/components/sortDropdown/SortDropdown';

export const mapStateToProps = (state: AccommodationState): Pick<SortDropdownStateProps, 'selectedValue' | 'sortOptions'> => ({
    selectedValue: state.filters.sort,
    sortOptions: displayValues.searchResultsSortOptions,
});

export const mapDispatchToProps = { triggerFetch: fetchHotels, filterChange: filterActions.changeSort };

export const SearchResultsSortDropdown = connect(mapStateToProps, mapDispatchToProps)(SortDropdown);
